// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import NavigationBar from './NavigationBar';
// import { data, useNavigate } from 'react-router-dom';
// import Config from '../config';
// import ErrorPage from './ErrorPage';


// const UserAndPlant = () => {
//   const [assignments, setAssignments] = useState([]);
//   const [error, setError] = useState('');
//   const [plants, setPlants] = useState([]);
//   const [roles, setRoles] = useState([]);
//   const navigate = useNavigate();

//   const [userId, setUserId] = useState(null);
//   const [plantId, setPlantId] = useState("");
//   const [plantName, setPlantName] = useState("");
//   const [access_token, setAccessToken] = useState(null);


//   console.log("AAAAAAAAAAAAAAAAa");
//   useEffect(() => {
//     const fetchPlants = async () => {
//       try {
//         const res = await axios.get(`/sso/plants/`, {
//           withCredentials: true
//         });
//         console.log(res.data.data,"*******************")

//         setPlants(res.data.data || []);
//       } catch (err) {
//         setError("Failed to fetch plants");
//       }
//     };

//     fetchPlants();
//   }, []);

// //   const handlePlantSelection = async (plantUid) => {
// //   try {
// //     const selectedPlant = plants.find(
// //       (p) => p.plantUid === plantUid
// //     );
// //     console.log(plantUid,selectedPlant,"MMMMMMMMMMMMMMMMMMMMMMMMM");
// //     await axios.post(
// //       `/sso/change-plant/`,
// //       {
// //         plant_uid: plantUid,
// //         plant_data: selectedPlant
// //       },
// //       {
// //         withCredentials: true,
// //         headers: {
// //           "Content-Type": "application/json"
// //         }
// //       }
// //     );

// //     navigate("/users/dashboard");



// //   } catch (error) {
// //     console.error("Plant selection failed", error);
// //   }
// // };


//   // console.log(sessionStorage)
//   // if (!userId) {
//   //     return <ErrorPage />;
//   // }


//   const handlePlantSelection = async (plantUid) => {
//   try {

//     const selectedPlant = plants.find(
//       (p) => p.plantUid === plantUid
//     );

//     console.log(
//       plantUid,
//       selectedPlant,
//       "SELECTED PLANT"
//     );

//     const response = await axios.post(
//       `/sso/change-plant/`,
//       {
//         plant_uid: plantUid,
//         plant_data: selectedPlant
//       },
//       {
//         withCredentials: true,
//         headers: {
//           "Content-Type": "application/json"
//         }
//       }
//     );

//     console.log(response.data, "CHANGE PLANT RESPONSE");

//     // ✅ FULL PAGE RELOAD
//     window.location.href = "/users/dashboard";

//   } catch (error) {

//     console.error(
//       "Plant selection failed",
//       error
//     );
//   }
// };


//   return (
//     <div>
//       <div
//         className="contentMain">
//         <div className="mt-4">
//           <br />
//           <div
//             className="border-radius-8 p-3 mt-3">

//             <div className="d-flex flex-wrap justify-content-center text-center">

//               {plants.map((plant, index) => (
//                 <div
//                   key={index}
//                   className="col-md-3 bg-white ml-3 mb-3"
//                   onClick={() => handlePlantSelection(plant.plantUid)}
//                   style={{ cursor: 'pointer' }}
//                 >
//                   <div className="p-4 font18">
//                     {plant.plantName}
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//           {/* {error && <p className="text-danger mt-3">{error}</p>} */}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default UserAndPlant;


import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../Sso_ums/SsoPlant.css'; // ← reuse the exact same CSS

const UserAndPlant = () => {
  const [plants, setPlants] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [selectingPlantId, setSelectingPlantId] = useState(null);

  useEffect(() => {
    const fetchPlants = async () => {
      try {
        const res = await axios.get(`/sso/plants/`, {
          withCredentials: true
        });
        setPlants(res.data.data || []);
      } catch (err) {
        setError("Failed to fetch plants");
      } finally {
        setLoading(false);
      }
    };

    fetchPlants();
  }, []);

  const handlePlantSelection = async (plantUid) => {
    if (!plantUid) {
      setError('Invalid plant change request. Please try again.');
      return;
    }

    const selectedPlant = plants.find(p => p.plantUid === plantUid);
    if (!selectedPlant) {
      setError('Plant you\'re trying to change to is not in your list. Please refresh.');
      return;
    }

    if (selectingPlantId) return;
    setSelectingPlantId(plantUid);
    setError('');

    try {
      const response = await axios.post(`/sso/change-plant/`, {
        plant_uid: plantUid,
        plant_data: selectedPlant
      }, {
        withCredentials: true,
        headers: { 'Content-Type': 'application/json' },
        timeout: 15000,
      });

      if (!response.data || response.data.success === false) {
        throw new Error(response.data?.error || 'Plant change failed');
      }

      window.location.href = '/users/dashboard';
    } catch (err) {
      console.error('Plant change error:', err);

      if (err.code === 'ECONNABORTED') {
        setError('Request timeout. Please try again.');
      } else if (err.response) {
        const status = err.response.status;
        const serverMsg = err.response.data?.error || err.response.data?.message;
        if (status === 401) {
          setError('Session expired. Please log in again through SSO.');
        } else if (status === 409) {
          setError('Could not change plant due to conflict. Please refresh.');
        } else {
          setError(serverMsg || `Plant change failed (Error ${status})`);
        }
      } else if (err.request) {
        setError('Network error: Unable to reach server. Check your connection.');
      } else {
        setError(err.message || 'Failed to change plant. Please try again.');
      }
    } finally {
      setSelectingPlantId(null);
    }
  };

  return (
    <div className="plant-selection-container">
      <div className="plant-selection-title">
        <h2>Change Your Plant</h2>
      </div>

      {/* Loading state */}
      {loading && (
        <div className="plant-loading">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-3">Loading your plants...</p>
        </div>
      )}

      {/* Error state */}
      {error && !loading && (
        <div className="plant-error">
          <p>{error}</p>
        </div>
      )}

      {/* Plant grid (only when loaded, no error, and plants exist) */}
      {!loading && !error && plants.length > 0 && (
        <div className="plant-grid">
          {plants.map((plant, index) => (
            <div
              key={index}
              className="plant-card"
              onClick={() => handlePlantSelection(plant.plantUid)}
              role="button"
              tabIndex={0}
              onKeyPress={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  handlePlantSelection(plant.plantUid);
                }
              }}
            >
              <div className="plant-card-body">
                {plant.isBasePlant && (
                  <span className="base-plant-badge">BASE PLANT</span>
                )}
                <h3 className="plant-name">{plant.plantName}</h3>
                <p className="plant-location">
                  {plant.location || "Location not available"}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Empty state (no plants, no error, not loading) */}
      {!loading && !error && plants.length === 0 && (
        <div className="plant-error">
          <p>No plants assigned to you.</p>
        </div>
      )}
    </div>
  );
};

export default UserAndPlant;